<div class="mtlr-3" style="display:flex;flex-direction: column;">
    <div>
        <app-product-toolbox [fieldsErrorsControl]="fieldsErrorsControl" [selectedNode]="selectedNode" (buttonAction)="onButtonAction($event)"></app-product-toolbox>
    </div>
    <div *ngIf="sendMessageLoading$ | async" style="padding-top: 300px;">
        <app-loading></app-loading>
    </div>
    <div *ngIf="!(sendMessageLoading$ | async)" class="scroll-container" style="height: calc(100vh - 235px);">
        <div *ngIf="selectedNode">

            <div *ngIf="isInstanceOfFormlyView()">
                <app-formly-detailed-view  #formly_detailed_view_component [selectedNode]="selectedNode" (validate)="onValidate()" (modelChange)="onFormlyDetailedModelChange($event)"></app-formly-detailed-view>
            </div>

            <div *ngIf="isInstanceOfFormlyDrugIngredientsFormlyView()">
                <app-formly-drug-ingredients-view  #formly_detailed_view_component [selectedNode]="selectedNode" (validate)="onValidate()" (modelChange)="onFormlyDetailedModelChange($event)"></app-formly-drug-ingredients-view>
            </div>

            <div *ngIf="isInstanceOfListView()">
                <app-list-detailed-view  [selectedNode]="selectedNode" (buttonAction)="onButtonAction($event)" (selectedNodeChange)="onSelectedNodeChange($event)" (removeNode)="onRemoveNode($event)"></app-list-detailed-view>
            </div>    
  
        </div>
    </div>
</div>
